import {InstitutionType, EducationPhase} from 'src/types/enums';
import {ObjectByEnum} from 'src/types/store';
import {titleize} from 'shared/utils';

export interface InstitutionDetails {
  type: InstitutionType;
  singular: string;
  plural: string;
  example: string;
}

export const institutionDetailsMap: ObjectByEnum<InstitutionType, InstitutionDetails> = {
  [InstitutionType.HIGH_SCHOOL]: {
    type: InstitutionType.HIGH_SCHOOL,
    singular: 'High School',
    plural: 'High Schools',
    example: 'Lincoln High, Stockton, CA',
  },
  [InstitutionType.COMMUNITY_COLLEGE]: {
    type: InstitutionType.COMMUNITY_COLLEGE,
    singular: 'Community College',
    plural: 'Community Colleges',
    example: 'City College of San Francisco',
  },
};

export type CoreEducationPhase =
  | EducationPhase.HIGH_SCHOOL
  | EducationPhase.COMMUNITY_COLLEGE
  | EducationPhase.UNDERGRADUATE
  | EducationPhase.ADULT_LEARNER;

const educationPhases: CoreEducationPhase[] = [
  EducationPhase.HIGH_SCHOOL,
  EducationPhase.COMMUNITY_COLLEGE,
  EducationPhase.UNDERGRADUATE,
  EducationPhase.ADULT_LEARNER,
];

export const educationPhaseOptions = educationPhases.map((educationPhase) => {
  const text = (phase: string): string => titleize(phase.replace('-', ' '));

  return {
    _id: educationPhase,
    value: educationPhase,
    text: text(educationPhase),
    label: text(educationPhase),
  };
});
